


































































import { Component, Mixins } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";
import { HomeInfo } from "@/interfaces/general";
import HomeContent from "@/components/HomeContent.vue";

@Component({
  metaInfo() {
    return {
      title: "Mos - Ecosystem"
    };
  },
  components: { HomeContent },
  computed: {},
  methods: {}
})
export default class EcoSystem extends Mixins(GlobalMixin) {
  ecoInfo: HomeInfo[] = [
    {
      title: "Features",
      text: [
        "Better information presented at the right time, in the right way and to the right people to make better decisions.",
        "Automated reports ",
        "Data mining, automated task management, use of dashboard engines.",
        "Improved data visibility and transparency of all activities.",
        "Enhanced operational security.",
        "Tools for business intelligence & data science.",
        "Cost management."
      ],
      image: "ecosystem/Features.svg",
      alignText: "left",
      redirect: false
    },
    {
      title: "Design",
      text: [
        "The MOS design is based on a cloud architecture which allows the integration of different technologies to create the clouds, that is, the IT environments that extract, group and share the scalable resources in the EDV network."
      ],
      image: "ecosystem/Design.svg",
      alignText: "right",
      redirect: false
    }
  ];
}
